<template>
  <!-- RFM自定义分析 -->
  <div class="member-level" style="margin: 10px 20px">
    <div class="section-right-content-box">
      <div class="rfmTitle">
        RFM 自定义分析<span
          class="top-panel_span"
          style="margin-right: 20px; margin-left: 20px"
          >R:最近一次购买时间</span
        >
        <span class="top-panel_span" style="margin-right: 20px"
          >F:购买次数</span
        >
        <span class="top-panel_span">M:购买金额</span>
      </div>
      <div
        class=""
        style="border-top: 1px solid #f0f0f0; margin: 16px -20px 30px -28px"
      ></div>
      <!-- RFM自定义分析表格 -->
      <div class="table-box">
        <div class="table-panel">
          <div class="left">
            <el-row class="header-row">
              <el-col :span="11">
                <div class="header-top"></div>
                <div class="header-cell">会员类型</div>
              </el-col>
              <el-col :span="13">
                <div class="header-top"></div>
                <div class="header-cell">条件设置</div>
              </el-col>
            </el-row>
            <el-row
              class="table-row"
              v-for="(item, index) in tableData"
              :key="index"
            >
              <!-- 会员类型 -->
              <el-col :span="11" class="table-col">
                <div class="col-cell">{{ item.name }}</div>
              </el-col>
              <!-- 条件设置 -->
              <el-col :span="13" class="table-col">
                <div class="col-cell">
                  {{ item.condition }}
                  <span v-if="index === 9">
                    <el-select
                      style="width: 85px"
                      v-model="value2"
                      placeholder="请选择"
                      @change="change"
                    >
                      <el-option
                        v-for="item in options2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="right">
            <el-row class="header-row">
              <!-- 会员数 -->
              <el-col :span="5">
                <div class="header-top"></div>
                <div class="header-cell">会员数(人)</div>
              </el-col>
              <!-- 消费金额 -->
              <el-col :span="5">
                <div class="header-top"></div>
                <div class="header-cell">消费金额(元)</div>
              </el-col>
              <!-- 客单价 -->
              <el-col :span="4">
                <div class="header-top"></div>
                <div class="header-cell">客单价(元)</div>
              </el-col>
              <!-- 占比分析 -->
              <el-col :span="6">
                <div class="header-top">占比分析</div>
                <div class="header-cell">
                  <el-row type="flex" justify="space-between">
                    <el-col :span="12">
                      <span class="circle member-count-circle"></span>
                      <span class="price-label">会员数</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="circle"></span>
                      <span class="price-label">成交金额</span>
                    </el-col>
                  </el-row>
                  <div></div>
                </div>
              </el-col>
              <!-- 相关操作 -->
              <el-col :span="4" style="text-align: center">
                <div class="header-top"></div>
                <div class="header-cell">相关操作</div>
              </el-col>
            </el-row>

            <el-row
              class="table-row"
              v-for="(item, index) in ConsumerCustomers"
              :key="index"
            >
              <el-col :span="5" class="table-col">
                <div class="col-cell member-count-cell">
                  {{ item.buyerNum }}
                </div>
              </el-col>
              <el-col :span="5" class="table-col">
                <div class="col-cell col-cell-price">{{ item.amount }}</div>
              </el-col>
              <el-col :span="4" class="table-col">
                <div class="col-cell col-cell-price">
                  {{ item.customerPrice }}
                </div>
              </el-col>
              <el-col :span="6" class="table-col">
                <div class="price-cell">
                  <div class="price-item">
                    <span class="price-span">{{ item.memberPercent }}%</span>
                    <el-progress
                      :percentage="item.memberPercent"
                      :show-text="false"
                      style="
                        float: right;
                        width: 105px;
                        margin-top: 7px;
                        margin-right: 10px;
                      "
                    ></el-progress>
                  </div>
                  <div class="price-item">
                    <span class="price-span member-count"
                      >{{ item.buyerMoneyPercent }}%</span
                    >
                    <el-progress
                      :percentage="item.buyerMoneyPercent"
                      color="rgba(255, 118, 0, 1)"
                      :show-text="false"
                      style="
                        float: right;
                        width: 105px;
                        margin-top: 7px;
                        margin-right: 10px;
                      "
                    ></el-progress>
                  </div>
                </div>
              </el-col>
              <el-col :span="4" class="table-col" style="text-align: center">
                <span
                  class="col-cell marketing-cell"
                  @click="Affiliate_marketing(item, index)"
                  v-zoom="{ from: '数据分析-RFM自定义分析', name: '会员营销' }"
                  v-if="item.buyerNum != 0"
                  >会员营销</span
                >
                <span
                  class="col-cell marketing-cell marketing-cellDefulat"
                  v-else
                  >会员营销</span
                >
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  RFM_Customize_Analyse,
  queryByNumChange,
} from "@/api/analysis/rfmStandard";

// import { close } from 'fs';
export default {
  name: "RFM_custom_analysis",
  data() {
    return {
      options2: [
        {
          value: "20",
          label: "20",
        },
        {
          value: "50",
          label: "50",
        },
        {
          value: "100",
          label: "100",
        },
        {
          value: "200",
          label: "200",
        },
      ],
      value2: "20",
      time: "",
      levelList: [
        {
          id: "cake-chart-0",
        },
        {
          id: "cake-chart-1",
        },
        {
          id: "cake-chart-2",
        },
        {
          id: "cake-chart-3",
        },
        {
          id: "cake-chart-4",
        },
      ],
      /*
       * 表格内容
       * */
      tableData: [
        {
          m_bf: 10,
          momey: "10000.00",
          p_bf: 30,
          people: "10",
          price: "1000.00",
          name: "售后期客户",
          condition: "R ≤ 7 ",
          day: "7",
        },
        {
          m_bf: 0,
          momey: "0",
          p_bf: 0,
          people: "0",
          price: "0",
          name: "活跃期客户",
          condition: "7 < R ≤ 30",
          day: "730",
        },
        {
          m_bf: 10,
          momey: "100.00",
          p_bf: 10,
          people: "1",
          price: "100.00",
          name: "沉默期客户",
          condition: "30 < R ≤ 90",
          day: "3090",
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "睡眠期客户",
          condition: "90 < R ≤ 120",
          day: "90120",
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "流失期客户",
          condition: "R > 120",
          day: "120",
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "兴趣客户",
          condition: " F = 0",
          number: "1",
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "新客户",
          condition: "	F = 1",
          number: "2",
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "回头客",
          condition: "	F = 2",
          number: "3",
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "老客户",
          condition: "F ≥ 3",
          number: "4",
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "低消费客户",
          condition: "0 < M ≤  ",
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "中低消费客户",
          condition: "	20 < M ≤ 50",
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "中等消费客户",
          condition: "	50 < M ≤ 100",
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "中高消费的客户",
          condition: "100 < M ≤ 150",
        },
        {
          m_bf: 0,
          momey: "",
          p_bf: 0,
          people: "",
          price: "",
          name: "高消费客户",
          condition: "M > 150",
        },
      ],
      tableDataList: [],
      ConsumerCustomers: [],
    };
  },
  mounted() {
    // this.info();
    this.getInfo();
    this.change();
  },
  methods: {
    change() {
      queryByNumChange({ start: this.value2 }).then((res) => {
        console.log(res);
        this.ConsumerCustomers = this.tableDataList.concat(res.data);
        if (this.value2 == "20") {
          this.tableData[10].condition = "20 < M ≤ 50";
          this.tableData[11].condition = "50 < M ≤ 100";
          this.tableData[12].condition = "100 < M ≤ 150";
          this.tableData[13].condition = "M > 150";
        } else if (this.value2 == "50") {
          this.tableData[10].condition = "50 < M ≤ 100";
          this.tableData[11].condition = "100 < M ≤ 200";
          this.tableData[12].condition = "200 < M ≤ 300";
          this.tableData[13].condition = "M > 300";
        } else if (this.value2 == "100") {
          this.tableData[10].condition = "100 < M ≤ 200";
          this.tableData[11].condition = "200 < M ≤ 300";
          this.tableData[12].condition = "300 < M ≤ 400";
          this.tableData[13].condition = "M > 400";
        } else if (this.value2 == "200") {
          this.tableData[10].condition = "200 < M ≤ 400";
          this.tableData[11].condition = "400 < M ≤ 600";
          this.tableData[12].condition = "600 < M ≤ 800";
          this.tableData[13].condition = "M > 800";
        }
      });
    },
    Affiliate_marketing(obj, index) {
      console.log(obj);
      let self = this;
      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/member_send",
        query: {
          tabIndex: 1,
          type: "",
          index,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    getInfo() {
      RFM_Customize_Analyse().then((res) => {
        console.log(res.data,111);
        this.tableDataList = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Microsoft YaHei";
}
@mixin translateX($number) {
  -webkit-transform: translateX($number);
  -moz-transform: translateX($number);
  -ms-transform: translateX($number);
  -o-transform: translateX($number);
  transform: translateX($number);
}
@mixin translateY($number) {
  -webkit-transform: translateY($number);
  -moz-transform: translateY($number);
  -ms-transform: translateY($number);
  -o-transform: translateY($number);
  transform: translateY($number);
}
@mixin translate($number, $number2) {
  -webkit-transform: translateX($number) translateY($number2);
  -moz-transform: translateX($number) translateY($number2);
  -ms-transform: translateX($number) translateY($number2);
  -o-transform: translateX($number) translateY($number2);
  transform: translateX($number) translateY($number2);
}
/deep/.el-progress-bar__inner {
  background-color: #7F85E9;
}
.section-right-content-box {
  min-width: 1046px;
  background-color: #fff;
  /*box-shadow: 0px 8px 20px rgba(139, 156, 188, 0.16);*/
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  padding: 33px 20px 16px 28px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid rgba(230, 230, 230, 1);
  opacity: 1;
  margin-top: 10px;
  .top-panel_span {
    font-size: 14px;
    // font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #333333;
    opacity: 1;
  }
}
.rfmTitle {
  font-size: 16px;
  // font-family: PingFang SC;
  font-weight: bold;
  color: #2e3458;
  margin: -15px 0 10px 0;
}

.table-box {
  margin-top: 14px;
  .table-panel {
    display: flex;
    border: 1px solid #e1e1e6;
    .left {
      width: 30%;
    }
    .right {
      width: 70%;
    }
    .header-row {
      padding: 17px 0 14px 15px;
      border-bottom: 1px solid #f2f2f2;
      .header-top {
        height: 20px;
        color: #333333;
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        text-align: center;
      }
      .header-cell {
        overflow: hidden;
        margin-top: 8px;
        color: #333333;
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        // .price-label {
        //   // float: left;
        // }
        .member-count-label {
          padding-left: 16px;
        }
        .circle {
          display: inline-block;
          // float: left;
          width: 8px;
          height: 8px;
          margin-right: 4px;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          border-radius: 50%;
          background-color: #7F85E9;
          // margin-top: 4px;
          // margin-left: 2px;
        }
        .member-count-circle {
          background-color: #FF974A;
        }
      }
    }
    .table-row {
      padding-bottom: 10px;
      padding-left: 15px;
      border-bottom: 1px solid #f2f2f2;
      line-height: 52px;
      .table-col {
        display: inline;
        vertical-align: middle;
        min-height: 10px;
        .col-cell {
          font-size: 14px;
          color: #666666;
              border-radius: 3px;
        }
        .member-count-cell {
          color: #7F85E9;
          font-size: 16px;
        }
        .col-cell-price {
          color: #FF974A;
          font-size: 16px;
        }
        .marketing-cell {
          padding: 6px;
          color: #fe4d45;
              border-radius: 3px;
          cursor: pointer;
          background: #fff;
          border: 1px solid #fe4d45 ;
        }
        .marketing-cell:hover {
          background: #fe4d45;;
          color: #fff;
        }
        .marketing-cellDefulat {
          color: #909399;
          background: #f4f4f5;
          border-color: #d3d4d6;
        }
        .marketing-cellDefulat:hover {
          background: #cccccc;
          color: #fff;
          cursor: not-allowed;
        }
      }
      .price-cell {
        margin-top: 6px;
        .price-item {
          overflow: hidden;
          line-height: 20px;
          .price-span {
            float: left;
            color: #7F85E9;
            font-size: 14px;
            font-weight: 500;
          }
          .member-count {
            color: #FF974A;
          }
        }
      }
    }
    .table-row:last-child {
      border-bottom: none;
    }
  }
}
</style>
